import { defaultCss } from "survey-core";

// The content classes a composite property editor renders its inner panel with: the paddings
// around it belong to the property grid row, not to the panel nested in it.
const nopaddingContent = "spg-question__content spg-question__nopadding";

export var propertyGridCss = {
  root: "spg-root-modern",
  rootTheme: "",
  container: "spg-container-modern",
  header: "spg-title spg-container-modern__title",
  body: "spg-body",
  bodyEmpty: "spg-body spg-body--empty",
  footer: "spg-footer spg-body__footer spg-clearfix",
  title: "",
  description: "",
  logo: "spg-logo",
  logoImage: "spg-logo__image",
  headerText: "spg-header__text",
  navigationButton: "",
  completedPage: "spg-completedpage",
  navigation: {
    complete: "spg-btn spg-footer__complete-btn",
    prev: "spg-btn spg-footer__prev-btn",
    next: "spg-btn spg-footer__next-btn",
    start: "spg-btn spg-footer__start-btn",
    preview: "spg-btn spg-footer__preview-btn",
    edit: "spg-btn spg-footer__edit-btn"
  },
  panel: {
    withFrame: "",
    nested: "",
    expandableAnimating: "",
    title: "spg-title spg-panel__title",
    titleBar: "sd-action-title-bar spg-action-title-bar",
    contentEnter: "spg-panel__content--enter",
    contentLeave: "spg-panel__content--leave",
    titleExpandable: "spg-panel__title--expandable",
    titleExpanded: "spg-panel__title--expanded",
    titleCollapsed: "spg-panel__title--collapsed",
    titleOnError: "spg-panel__title--error",
    description: "spg-description spg-panel__description",
    container: "spg-panel spg-row__panel",
    content: "spg-panel__content",
    icon: "spg-panel__icon",
    iconExpanded: "spg-panel__icon--expanded",
    footer: "spg-panel__footer",
    requiredMark: "spg-panel__required-text"
  },
  paneldynamic: {
    nested: "",
    mainRoot: "spg-question spg-row__question",
    root: "spg-paneldynamic",
    navigation: "spg-paneldynamic__navigation",
    header: "spg-question__header",
    title: "spg-title spg-question__title",
    button: "",
    buttonRemove: "",
    buttonAdd: "spg-paneldynamic__add-btn",
    panelsContainer: "",
    panelWrapper: "spg-paneldynamic__panel-wrapper",
    panelWrapperList: "",
    progressTop: "spg-paneldynamic__progress spg-paneldynamic__progress--top",
    progressBottom:
      "spg-paneldynamic__progress spg-paneldynamic__progress--bottom",
    buttonPrev: "spg-paneldynamic__prev-btn",
    buttonNext: "spg-paneldynamic__next-btn",
    progressContainer: "spg-paneldynamic__progress-container",
    progress: "spg-progress",
    progressBar: "spg-progress__bar",
    progressText: "spg-paneldynamic__progress-text",
    panelFooter: "spg-panel__footer",
    separator: "spg-paneldynamic__separator",
    footer: "spg-paneldynamic__footer",
    footerButtonsContainer: "spg-paneldynamic__buttons-container",
  },
  progress: "spg-progress spg-body__progress",
  progressBar: "spg-progress__bar",
  progressText: "spg-progress__text",
  progressTextInBar: "spg-hidden",
  page: {
    root: "spg-page spg-body__page",
    title: "spg-title spg-page__title",
    content: "spg-page__content",
    description: "spg-description spg-page__description"
  },
  pageTitle: "spg-title spg-page__title",
  pageDescription: "spg-description spg-page__description",
  row: "spg-row spg-clearfix",
  rowEnter: "spg-row--enter",
  rowLeave: "spg-row--leave",
  rowDelayedEnter: "spg-row--delayed-fade-in",
  rowMultiple: "spg-row--multiple",
  question: {
    withFrame: "",
    nested: "",
    mainRoot: "spg-question spg-row__question",
    flowRoot: "spg-question spg-row__question spg-row__question--flow",
    asCell: "spg-table__cell",
    header: "spg-question__header",
    headerLeft: "spg-question__header--location--left sd-formbox__label",
    headerTop: "spg-question__header--location--top",
    headerBottom: "spg-question__header--location--bottom",
    content: "spg-question__content",
    contentLeft: "spg-question__content--left",
    titleLeftRoot: "spg-question--location--left sd-formbox",
    titleOnAnswer: "spg-question__title--answer",
    titleOnError: "spg-question__title--error",
    title: "spg-title spg-question__title",
    titleBar: "sd-action-title-bar spg-action-title-bar",
    requiredMark: "spg-question__required-text",
    number: "spg-question__num",
    description: "spg-description spg-question__description",
    descriptionUnderInput: "spg-description spg-question__description",
    comment: "spg-comment",
    required: "spg-question--required",
    titleRequired: "spg-question__title--required",
    indent: 0,
    footer: "spg-question__footer",
    formGroup: "spg-question__form-group",
    hasError: "",
    readOnly: "sd-question--readonly spg-question--disabled",
    confirmDialog: "spg-popup--confirm sv-popup--confirm svc-creator-popup",
    errorsContainerBottom: "spg-question__erbox--below-question",
  },
  image: { root: "spg-image", image: "sv_image_image" },
  error: {
    root: "spg-question__erbox",
    icon: "spg-question__erbox-icon",
    item: "",
    locationTop: "spg-question__erbox--location--top",
    locationBottom: "spg-question__erbox--location--bottom"
  },
  checkbox: {
    ...defaultCss.checkbox,
  },
  radiogroup: {
    ...defaultCss.radiogroup,
  },

  boolean: {
    ...defaultCss.boolean,

    mainRoot: "spg-question spg-row__question spg-question--boolean",
    rootCheckbox: "spg-selectbase",
    checkboxItem: "spg-checkbox",
  },

  text: {
    ...defaultCss.text,
    content: "spg-question__content spg-text__content",
  },
  multipletext: {
    root: "spg-multipletext",
    item: "spg-multipletext__item",
    itemTitle: "spg-multipletext__item-title",
    content: "spg-multipletext__content spg-text__content",
    row: "spg-multipletext__row",
    cell: "spg-multipletext__cell"
  },
  dropdown: {
    ...defaultCss.dropdown,
    content: "spg-question__content spg-question__content--dropdown",
    popup: "spg-dropdown-popup svc-creator-popup",
  },
  tagbox: {
    ...defaultCss.tagbox,
    content: "spg-question__content spg-question__content--dropdown spg-question__content--tagbox",
  },
  buttongroup: {
    ...defaultCss.buttongroup,
    itemReadOnly: "sv-button-group__item--disabled",
    popup: "spg-dropdown-popup svc-creator-popup",
  },
  imagepicker: {
    root: "spg-imagepicker",
    item: "spg-imagepicker__item",
    itemInline: "spg-imagepicker__item--inline",
    itemChecked: "spg-imagepicker__item--checked",
    itemReadOnly: "spg-imagepicker__item--disabled",
    itemHover: "spg-imagepicker__item--allowhover",
    label: "spg-imagepicker__label",
    itemControl: "spg-imagepicker__control",
    image: "spg-imagepicker__image",
    itemText: "spg-imagepicker__text",
    clearButton: "spg-btn",
    other: "spg-comment spg-question__other"
  },
  matrix: {
    mainRoot: "spg-question spg-row__question",
    tableWrapper: "spg-matrix spg-table-wrapper",
    root: "spg-table",
    header: "spg-question__header",
    rowError: "spg-matrix__row--error",
    cell: "spg-table__cell spg-matrix__cell",
    headerCell: "spg-table__cell spg-table__cell--header",
    label: "spg-item spg-radio spg-matrix__label",
    itemValue: "spg-visuallyhidden spg-item__control spg-radio__control",
    itemChecked: "spg-radio--checked",
    itemReadOnly: "spg-item--disabled spg-radio--disabled",
    itemHover: "spg-radio--allowhover",
    materialDecorator: "spg-item__decorator spg-radio__decorator",
    itemDecorator: "spg-item__svg spg-radio__svg",
    cellText: "spg-matrix__text",
    cellTextSelected: "spg-matrix__text--checked",
    cellTextReadOnly: "spg-matrix__text--disabled",
  },
  matrixdropdown: {
    mainRoot: "spg-question spg-row__question",
    tableWrapper: "spg-table-wrapper",
    root: "spg-table",
    header: "spg-question__header",
    cell: "spg-table__cell",
    headerCell: "spg-table__cell spg-table__cell--header",
    emptyCell: "spg-table__cell--empty",
    rowEnter: "spg-table__row--enter",
    rowLeave: "spg-table__row--leave",
  },
  matrixdynamic: {
    mainRoot: "spg-question spg-row__question",
    tableWrapper: "spg-table-wrapper",
    root: "spg-table spg-matrixdynamic",
    header: "spg-question__header",
    content: "spg-matrixdynamic__content spg-text__content",
    cell: "spg-table__cell",
    row: "spg-table__row",
    rowDisabled: "spg-table__row-disabled",
    rowReadOnly: "spg-table__row-readonly",
    headerCell: "spg-table__cell spg-table__cell--header",
    button: "spg-btn",
    detailRow: "spg-table__row spg-table__row--detail",
    detailButton: "",
    detailButtonExpanded: "",
    detailIcon: "spg-detail-panel__icon",
    detailIconExpanded: "spg-detail-panel__icon--expanded",
    detailPanelCell: "spg-table__cell spg-table__cell--detail-panel",
    actionsCell: "spg-table__cell spg-table__cell--actions",
    buttonAdd: "spg-matrixdynamic__add-btn",
    buttonRemove: "spg-matrixdynamic__remove-btn",
    iconAdd: "",
    iconRemove: "",
    dragElementDecorator: "spg-drag-element__svg",
    iconDragElement: "icon-drag-24x24",
    iconDrag: "spg-matrixdynamic__drag-element",
    toolbar: "",
    toolbarTop: "",
    toolbarBottom: "",
    dragDropGhostPositionTop: "spg-matrixdynamic__drag-drop-ghost-position-top",
    dragDropGhostPositionBottom: "spg-matrixdynamic__drag-drop-ghost-position-bottom",
    noRowsSection: "spg-matrixdynamic__placeholder",
    noRowsText: "spg-matrixdynamic__placeholder-text",
    cellQuestionWrapper: "spg-table__question-wrapper",
    draggedRow: "spg-matrixdynamic__dragged-row",
    emptyCell: "spg-table__cell--empty",
    rowEnter: "spg-table__row--enter",
    rowLeave: "spg-table__row--leave",
  },
  rating: {
    root: "spg-rating",
    item: "spg-rating__item",
    selected: "spg-rating__item--selected",
    minText: "spg-rating__min-text",
    itemText: "spg-rating__item-text",
    maxText: "spg-rating__max-text",
    readOnly: "spg-rating--disabled"
  },
  comment: {
    ...defaultCss.comment,
    content: "spg-question__content",
  },
  expression: "",
  file: {
    root: "spg-file",
    other: "spg-comment spg-question__other",
    placeholderInput: "spg-visuallyhidden",
    preview: "spg-file__preview",
    fileSign: "spg-hidden",
    fileSignBottom: "spg-file__sign",
    fileDecorator: "spg-file__decorator",
    fileInput: "spg-visuallyhidden",
    noFileChosen: "spg-description spg-file__no-file-chosen",
    chooseFile: "spg-btn spg-file__choose-btn",
    readOnly: "spg-file__choose-btn--disabled",
    removeButton: "spg-hidden",
    removeButtonBottom: "spg-btn spg-file__clean-btn",
    removeFile: "spg-hidden",
    removeFileSvg: "spg-file__remove-svg",
    wrapper: "spg-file__wrapper"
  },
  signaturepad: {
    root: "spg-signaturepad sjs_sp_container",
    small: "spg-row__question--small",
    controls: "sjs_sp_controls",
    clearButton: "sjs_sp_clear"
  },
  propertygrid_bindings: {
    content: `${nopaddingContent} spg-question-group`
  },
  propertygrid_restfull: {
    content: `${nopaddingContent} spg-restfull`
  },
  propertygrid_masksettings: {
    content: `${nopaddingContent} spg-masksettings`
  },
  propertygrid_regionalformat: {
    content: `${nopaddingContent} spg-regionalformat`
  },
  propertygrid_header: {
    mainRoot: "spg-header",
    content: nopaddingContent
  },
  coloralpha: {
    content: `${nopaddingContent} spg-question__content-coloralpha`
  },
  font: {
    content: `${nopaddingContent} spg-question-composite__content`
  },
  backgroundcornerradius: {
    content: `${nopaddingContent} spg-question-composite__content`
  },
  saveData: {
    root: "",
    saving: "",
    error: "",
    success: "",
    saveAgainButton: ""
  },
  window: {
    root: "sv_window",
    body: "sv_window_content",
    header: {
      root: "sv_window_title",
      title: "",
      button: "",
      buttonExpanded: "",
      buttonCollapsed: ""
    }
  },
  actionBar: {
    root: "sd-action-bar spg-action-bar",
  },
  spinedit: {
    root: "sd-formbox spg-spin-editor",
    control: "sd-formbox__input",
    increaseButtonIcon: "icon-arrow-up",
    decreaseButtonIcon: "icon-arrow-down",
    group: "sd-formbox__group"
  },
  color: {
    root: "sd-formbox spg-color-editor",
    control: "sd-formbox__input",
    colorInput: "spg-color-editor__color-input",
    colorSwatch: "spg-color-editor__swatch",
    swatch: "sd-color-swatch",
    swatchDisabled: "sd-color-swatch--disabled",
    colorDropdownIcon: "icon-drop-down-arrow",
    swatchIcon: "icon-dropper-16x16",
    iconClassName: "sd-color-swatch__icon",
    group: "sd-formbox__group"
  },
  fileedit: {
    root: "sd-formbox spg-file-edit",
    control: "sd-formbox__input",
    chooseButtonIcon: "icon-choosefile",
    clearButtonIcon: "icon-cancel-24x24",
    fileInput: "sd-visuallyhidden",
    chooseButton: "spg-file-edit__choose-button",
    chooseButtonDisabled: "sd-action--disabled",
    group: "sd-formbox__group"
  },
  linkvalue: {
    content: "spg-link"
  }
};
